const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '一手爆料',
    desc: '遍布各大节目与赛事的前线线人网络，确保每日大赛黑料第一时间获取独家内幕，大赛吃瓜永远快人一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '交叉验证',
    desc: '每条爆料至少经过两个独立信源核实，黑料吃瓜群专设事实核查团队，杜绝虚假信息误导吃瓜群众。',
  },
  {
    icon: 'ri-group-line',
    title: '社群驱动',
    desc: '十万级活跃的黑料吃瓜群成员实时贡献线索与讨论，每日大赛黑料的优质内容离不开每一位吃瓜群众。',
  },
  {
    icon: 'ri-eye-line',
    title: '深度观察',
    desc: '不满足于表面八卦，每日大赛黑料持续追踪事件背后的深层逻辑，为大赛内幕提供有理有据的分析视角。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            每日大赛黑料为什么是吃瓜群众的不二之选
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all text-center group cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}